/* unplugin-vue-components disabled */import script from "./TrialFundWaitingTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./TrialFundWaitingTitle.vue?vue&type=script&setup=true&lang=js"

import "./TrialFundWaitingTitle.vue?vue&type=style&index=0&id=2c4e547f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c4e547f"]])

export default __exports__